import { Switch } from '@headlessui/react'
import cx from 'classnames'
import React from 'react'

type Props = {
  /** Label */
  label?: string
  /** Description */
  description?: string
  /** Html For tag */
  htmlFor: string
  /** On/off state */
  on: boolean
  /** On change function. */
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  /** True if the component is disabled. */
  disabled?: boolean
}

/** Taken from TailwindUI's toggle button:
 * https://tailwindui.com/components/application-ui/forms/toggles
 */

// Form toggle button
const ToggleButton: React.FC<Props> = ({
  label,
  htmlFor,
  on,
  onChange,
  disabled,
}) => {
  const handleValueChanged = (value: boolean) => {
    const simulatedChangeEvent = {
      target: { checked: value, alias: htmlFor },
    } as unknown as React.ChangeEvent<HTMLInputElement>

    onChange(simulatedChangeEvent)
  }
  return (
    <Switch.Group as="div" className="flex items-center">
      <Switch
        checked={on}
        onChange={handleValueChanged}
        className={cx(
          {
            ['bg-primary']: on && !disabled,
            ['bg-red-400']: !on && !disabled,
            ['bg-gray-400 dark:bg-gray-800']: !!disabled,
          },
          !!disabled ? 'cursor-not-allowed' : 'cursor-pointer',
          'relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent p-0 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-200 focus:ring-offset-2 dark:border-gray-600',
        )}
        disabled={!!disabled}
      >
        <span className="sr-only">{label}</span>
        <span
          aria-hidden="true"
          className={cx(
            on ? 'translate-x-5' : 'translate-x-0',
            'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
          )}
        />
      </Switch>
      <Switch.Label as="span" className="ml-3">
        <span className="text-sm font-medium">{label}</span>
      </Switch.Label>
    </Switch.Group>
  )
}

ToggleButton.defaultProps = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange: () => {},
}

export default ToggleButton
